import { UserRole } from '../types/auth';

export interface TestUser {
  id: string;
  role: UserRole;
  name: string;
  email: string;
  phone: string;
  address: string;
  password: string;
  position?: string;
  jobTitle?: string;
}

export const testUsers: TestUser[] = [
  {
    id: 'owner-1',
    role: 'owner',
    name: 'Test Owner',
    email: 'owner@test.com',
    password: 'owner123',
    phone: '555-0001',
    address: '123 Owner St'
  },
  {
    id: 'manager-1',
    role: 'manager',
    name: 'Test Manager',
    email: 'manager@test.com',
    password: 'manager123',
    phone: '555-0002',
    address: '456 Manager Ave'
  },
  {
    id: 'staff-1',
    role: 'staff',
    name: 'Test Staff',
    email: 'staff@test.com',
    password: 'staff123',
    phone: '555-0003',
    address: '789 Staff Rd'
  },
  {
    id: 'lead-1',
    role: 'lead',
    name: 'Test Lead',
    email: 'lead@test.com',
    password: 'lead123',
    phone: '555-0004',
    address: '321 Lead Ln'
  },
  {
    id: 'client-1',
    role: 'client',
    name: 'Test Client',
    email: 'client@test.com',
    password: 'client123',
    phone: '555-0005',
    address: '654 Client Blvd'
  }
];

export const findTestUser = (email: string, password: string): TestUser | undefined => {
  return testUsers.find(user => user.email === email && user.password === password);
};